var _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _path12, _path13, _path14, _path15, _circle3, _polygon5, _circle4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e5378a26-042d-4a36-80f1-957b4ecc48ee",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 840.5,
    height: 757.83115,
    viewBox: "0 0 840.5 757.83115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "534.25 438.618 418.25 300.618 185.404 302.746 44.156 440.325 47.01 442.159 45.991 442.159 45.991 728.324 533.937 728.324 533.937 442.159 534.25 438.618",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.371 300.912 273.455 470.811 273.455 728.324 533.937 728.324 533.937 438.491 418.371 300.912",
    fill: "#ec454f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 378.01459,
    y: 585.91537,
    width: 53.19723,
    height: 47.02019,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 378.01459,
    y: 504.52856,
    width: 53.19723,
    height: 46.27453,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.60242,
    y: 573.43886,
    width: 53.19723,
    height: 47.02019,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.60242,
    y: 492.05205,
    width: 53.19723,
    height: 46.27453,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 727.43053,
    width: 840.5,
    height: 2,
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "713.92 695.831 717.92 715.831 697.92 719.831 700.92 694.831 713.92 695.831",
    fill: "#a0616a"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "776.92 691.831 771.92 716.831 747.92 716.831 757.92 686.831 776.92 691.831",
    fill: "#a0616a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M978.66929,588.91557l4,27-5,59-4,22-17,72s-19,0-22-8l5-41s4-33,3-37-16-68-16-68-22,101-25,110-7,48-7,48-17,3-18,0-2-74-2-85,2-17,2-19-7.8786-97.47192-7.8786-97.47192Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M937.66929,782.91557s5,1,8,0,0-7,0-7h11s12,27,17,29,21,24,2,24a62.08559,62.08559,0,0,1-33-10s-2-9-11-10-15-12-15-12l13-24S932.66929,783.91557,937.66929,782.91557Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M890.66929,781.91557s-2,4-4,2-4-7-4-7-6-3-7,0-5,19-7,21-23,23-2,27,25-5,25-5-3-5,3-7,7-9,7-9l-4-30S893.66929,783.91557,890.66929,781.91557Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.66929,518.91557l3,52s14,33-5,32-7-33-7-33l-18.60235-46.40942Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M847.66929,503.91557l-3,52s-14,33,5,32,7-33,7-33l18.60236-46.40942Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#a0616a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 747.91927,
    cy: 293.83115,
    r: 26,
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M948.16929,375.41557s-7,28,7,35-44,17-48,0l2-8s8-10,6-19Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M932.66929,410.91557s-17.25519,1.61145-22.62756-9.69427c0,0-40.37244,2.69427-49.37244,39.69427l15,96s-16,28-14,31c0,0-10,28,82,29l40-2a55.64622,55.64622,0,0,0-1-17c-2-9-13-72-13-72s30-47,27-54-7.80438-34.60076-46.40222-45.80038C950.26707,406.11519,949.66929,411.91557,932.66929,410.91557Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M983.66929,434.91557l13,17s13,71,9,72-28,9-32,6-22-62-22-62Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M877.66929,429.91557l-17,11s-25,70-18,73,46,1,46,1Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M956.089,341.64757s-9.00568-19.51227-26.26654-15.00943-27.017,11.25708-27.76746,18.01132.37525,16.88562.37525,16.88562,1.87616-13.88373,13.88373-10.88183c6.38656,1.59664,14.68386,1.70714,21.05261,1.46071a9.19307,9.19307,0,0,1,9.57007,9.30845l-.31464,21.49316S971.62205,366.91557,956.089,341.64757Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M833.45954,349.21456H480.27425a6.54816,6.54816,0,0,1-6.54045-6.54046V180.50271a6.54815,6.54815,0,0,1,6.54045-6.54045H833.45954A6.54815,6.54815,0,0,1,840,180.50271V342.6741A6.54816,6.54816,0,0,1,833.45954,349.21456ZM480.27425,176.57844a3.92856,3.92856,0,0,0-3.92427,3.92427V342.6741a3.92856,3.92856,0,0,0,3.92427,3.92427H833.45954a3.92857,3.92857,0,0,0,3.92428-3.92427V180.50271a3.92857,3.92857,0,0,0-3.92428-3.92427Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.78588,
    cy: 160.32649,
    r: 26.64236,
    fill: "#ec454f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M594.06705,213.64934a4.4404,4.4404,0,1,0,0,8.88079H803.39989a4.44039,4.44039,0,0,0,0-8.88079Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M594.06705,240.2917a4.4404,4.4404,0,1,0,0,8.88079H684.1436a4.4404,4.4404,0,1,0,0-8.88079Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M512.10048,282.88511c-3.37772,0-6.12638,1.99223-6.12638,4.4404s2.74866,4.44039,6.12638,4.44039H800.9154c3.37771,0,6.12638-1.99223,6.12638-4.44039s-2.74867-4.4404-6.12638-4.4404Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M512.10048,309.52747c-3.37772,0-6.12638,1.99223-6.12638,4.4404s2.74866,4.44039,6.12638,4.44039H800.9154c3.37771,0,6.12638-1.99223,6.12638-4.44039s-2.74867-4.4404-6.12638-4.4404Z",
    transform: "translate(-179.75 -71.08443)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.09957,
    cy: 47.38212,
    r: 47.38212,
    fill: "#ec454f"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.1 124.408 575.284 98.747 560.469 73.086 590.1 73.086 619.73 73.086 604.915 98.747 590.1 124.408",
    fill: "#ec454f"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.48169,
    cy: 47.08636,
    r: 17,
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 768.87205,
    cy: 293.83115,
    rx: 4,
    ry: 5,
    fill: "#a0616a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAddress);
export default __webpack_public_path__ + "static/media/undraw_address.22708c1d99873c6938587bfe04b5b9b5.svg";
export { ForwardRef as ReactComponent };